import validator from "validator";
import message from "../../../../messages/finance";

const validateBankCardNumber = (bankAccountCardNumber) => {
  if (validator.isEmpty(bankAccountCardNumber)) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  if (!bankAccountCardNumber.trim()) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  if (bankAccountCardNumber.length != 19) {
    return message.BANK_ACCOUNT_CARD_NUMBER_INVALID;
  }

  return true;
};

const validateAmount = (amount, wallet) => {
  if (amount < parseInt(process.env.REACT_APP_MIN_AMOUNT_ASK_TRANSACTION)) {
    return message.AMOUNT_IS_LESS_THAN_AT_LEAST_AMOUNT_TRANSACTION;
  }

  const amountThatUserCanAskTransaction =
    wallet -
    parseInt(process.env.REACT_APP_AMOUNT_WALLET_BLOCK_ASK_TRANSACTION);
  if (amountThatUserCanAskTransaction < amount) {
    return message.AMOUNT_IS_MORE_THAN_AMOUNT_USER_CAN_ASK_TRANSACTION;
  }

  return true;
};

const validateFormAddPage = (info) => {
  const resValidateBankCardNumber = validateBankCardNumber(
    info.account_cart_number
  );

  if (resValidateBankCardNumber != true) {
    return resValidateBankCardNumber;
  }

  const resValidateAmount = validateAmount(info.amount, info.wallet);
  if (resValidateAmount != true) {
    return resValidateAmount;
  }

  return true;
};

export default validateFormAddPage;
